import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const DEFAULT_INITIAL_RESULTS_NUMBER = 20;
export const DEFAULT_LOAD_RESULTS_PER_PAGE = 10;

export const searchResultsInputs = [
  {
    name: "searchType",
    type: "string",
    required: true,
    enum: ["all", "faq", "page", "product"],
    defaultValue: "faq",
  },
  {
    name: "loadResultsPerPage",
    type: "number",
    defaultValue: DEFAULT_LOAD_RESULTS_PER_PAGE,
  },
  {
    name: "initialResultsNumber",
    type: "number",
    defaultValue: DEFAULT_INITIAL_RESULTS_NUMBER,
  },
  {
    name: "translations",
    type: "object",
    required: true,
    subFields: [
      {
        name: "searchResultsTitle",
        type: "string",
        defaultValue: "Results for {query}",
        description:
          "should contain '{count}' or '{query}' or both to show the appropriate values",
        required: true,
      },
      {
        name: "readMoreLabel",
        type: "string",
        defaultValue: "Read more",
        required: true,
      },
      {
        name: "noResultsLabel",
        type: "string",
        defaultValue: "No results found",
        required: true,
      },
      {
        name: "loadMoreLabel",
        type: "string",
        defaultValue: "Load more",
        description:
          "should contain '{0}' if you want to display the number from 'Load results per page'",
        required: true,
      },
    ],
    defaultValue: {
      searchResultsTitle: "Results for {query}",
      readMoreLabel: "Read more",
      noResultsLabel: "No results found",
      loadMoreLabel: "Load more",
    },
  },
] as const satisfies Inputs;

export const SearchResultsComponent: RegisteredComponent = {
  name: "Search Results",
  component: dynamic(async () =>
    withValidation(
      searchResultsInputs,
      (await import("./SearchResults")).SearchResults,
      "SearchResults"
    )
  ),
  inputs: searchResultsInputs,
};
